import { HttpClient, HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule, HammerModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgProgressbar  } from 'ngx-progressbar';
import { StorageModule } from '@ngx-pwa/local-storage';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { enGbLocale } from 'ngx-bootstrap/locale';
import { ToastrModule } from 'ngx-toastr';
import { AppComponent } from './app.component';
import { SharedModule } from './modules/shared/shared.module';
import { AppRoutes } from './app.routes';
import { ServerErrorInterceptor } from './modules/shared/interceptors/serverErrorInterceptor';
import { AuthModule } from './modules/auth/auth.module';
import { unAuthorisedComponent } from './unauthorised/unauthorised.component';
import { CustomToastrComponent } from './modules/shared/components/common/custom-toastr/custom-toastr.component';
import { AccessDeniedComponent } from './access-denied/access-denied.component';
import { IonicModule } from '@ionic/angular';
import { WtStorageService } from './modules/shared/services/wt-storage.service';
import { QuicklinkModule } from 'ngx-quicklink';
import { AzureDebugInterceptor } from './modules/shared/interceptors/azure-debug.interceptor';
import { UserAccountSelectComponent } from './modules/account-selection/components/user-accounts/user-accounts.component';
import { provideTranslateService } from '@ngx-translate/core';
import { NoAccessComponent } from './no-access/no-access.component';
import { MapsLoaderService } from './modules/shared/services/mapsLoader.service';
import { CoreModule } from './modules/core/core.module';
import { MsalRedirectComponent } from '@azure/msal-angular';

import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
defineLocale('engb', enGbLocale);

export function onAppInit(storage: WtStorageService): () => Promise<any> {
  return storage.loadAllDataInMemoryFromStorage;
}

export function googleMapsLoader(mapsLoaderService: MapsLoaderService) {
  return () => {
      return new Promise<void>((resolve) => {
        mapsLoaderService.loadGoogleMapsAPIs().subscribe(() => {
          resolve();
        });
      });
  };
}

const APP_MODULES = [CoreModule.forRoot(), SharedModule.forRoot()];

@NgModule({ declarations: [AppComponent, unAuthorisedComponent, UserAccountSelectComponent, AccessDeniedComponent, NoAccessComponent],
    bootstrap: [AppComponent, MsalRedirectComponent],
    imports: [AppRoutes,
        BrowserModule,
        HammerModule,
        QuicklinkModule,
        BrowserAnimationsModule,
        ToastrModule.forRoot({
            toastComponent: CustomToastrComponent,
            autoDismiss: true,
            maxOpened: 1,
        }),
        NgProgressbar,
        // WETRACK MODULES
        AuthModule.forRoot(),
        ...APP_MODULES,
        StorageModule.forRoot({ IDBNoWrap: true }),
        IonicModule.forRoot({
            scrollAssist: true,
        })
      ], 
      providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ServerErrorInterceptor,
            multi: true,
        },
        {
            provide: APP_INITIALIZER,
            useFactory: onAppInit,
            deps: [WtStorageService],
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AzureDebugInterceptor,
            multi: true,
        },
        {
            provide: APP_INITIALIZER,
            useFactory: googleMapsLoader,
            multi: true,
            deps: [MapsLoaderService]
        },
        provideHttpClient(withInterceptorsFromDi()),
                provideTranslateService({
            loader: provideTranslateHttpLoader({prefix:"./assets/i18n/translations/",suffix:".json", useHttpBackend: true}),
            fallbackLang: 'en',
            lang: 'en'
        })
    ] })
export class AppModule {}
